// Conceptos de "Capitalizaciones a cuentas propias" (Actividades de financiamiento).
// Deben existir siempre en el catálogo por defecto y se asignan automáticamente
// al confirmar un desglose: la salida (monto original) lleva el de signo negativo
// y la entrada neutralizante lleva el de signo positivo.

export const CAPITALIZACION_SALIDA = {
  conceptoCatalogo: "(-) Capitalizaciones a cuentas propias (s)",
  agrupacion: "Actividades de financiamiento",
  estadoFinanciero: "Flujo de Efectivo",
};

export const CAPITALIZACION_ENTRADA = {
  conceptoCatalogo: "(+) Capitalizaciones a cuentas propias (i)",
  agrupacion: "Actividades de financiamiento",
  estadoFinanciero: "Flujo de Efectivo",
};

export const CONCEPTOS_DEFAULT = [CAPITALIZACION_SALIDA, CAPITALIZACION_ENTRADA];

const norm = (s) =>
  (s || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

// Antepone los conceptos por defecto que no estén ya presentes (comparación
// sin acentos ni mayúsculas), preservando el resto del catálogo tal cual.
export const ensureDefaultConceptos = (conceptos = []) => {
  const existentes = new Set(
    conceptos
      .filter((c) => c.conceptoCatalogo?.trim())
      .map((c) => norm(c.conceptoCatalogo))
  );
  const faltantes = CONCEPTOS_DEFAULT.filter(
    (c) => !existentes.has(norm(c.conceptoCatalogo))
  );
  return [...faltantes, ...conceptos];
};
